export default "__VITE_ASSET__CNinAzSW__"